import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogResultService {

  private messageSource = new BehaviorSubject(JSON.stringify(null));
  currentMessage: Observable<string> = this.messageSource.asObservable();
  
  constructor() { }

  changeMessage(message: string) {
    this.messageSource.next(message)
  }

  getMessage() {
    return this.currentMessage;
  }
}
